var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q, Api } from "@http";
import { observable, action, runInAction } from "mobx";
import LoadingData from "@store/common/loadingData";
import { WoProgressStatus } from "@router/scenes/detail/woStatus";
var MessageStore = /** @class */ (function () {
    function MessageStore() {
        this.unReadMessages = new LoadingData([]);
        this.messagesDetail = new LoadingData([]);
    }
    MessageStore.prototype.getReactiveWoUnReadMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getReactiveWoUnReadMessages()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.unReadMessages.setLoadedData(data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MessageStore.prototype.getMessageDetail = function (id, isReactive) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            return __generator(this, function (_a) {
                promise = this.api().getMessageDetail(id, isReactive);
                // const data = await promise;
                // runInAction(() => {
                //   this.messagesDetail.setLoadedData(data.items);
                // });
                return [2 /*return*/, promise];
            });
        });
    };
    MessageStore.prototype.markAsRead = function (id, isReactive) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.api().markAsRead(id, isReactive);
                return [2 /*return*/];
            });
        });
    };
    MessageStore.prototype.sendMessage = function (id, sendMessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().sendMessage(id, sendMessage)];
            });
        });
    };
    MessageStore.prototype.replyMessage = function (id, replyMessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().replyMessage(id, replyMessage)];
            });
        });
    };
    MessageStore.prototype.getIsEnableCommunicationWithPM = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getIsEnableCommunicationWithPM()];
            });
        });
    };
    MessageStore.prototype.clearUnReadMessages = function () {
        this.unReadMessages = new LoadingData([]);
    };
    MessageStore.prototype.clearMessageDetail = function () {
        this.messagesDetail = new LoadingData([]);
    };
    MessageStore.prototype.getWoStatusTimeLines = function (woId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getWoStatusTimeLines(woId)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            var _a, _b;
                            var currentStatus = (_a = data.woStatusTimeLine) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.progress_status === WoProgressStatus.Current; });
                            (data === null || data === void 0 ? void 0 : data.woNum) && (_this.woStatusData = __assign(__assign({}, data), { lastUpdateTime: currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.local_operation_time, woStatusTimeLines: ((_b = data.woStatusTimeLine) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({
                                    content: item.progress_status === WoProgressStatus.Pending ? '' : item.status_description,
                                    time: item.local_operation_time,
                                    title: item.status_display_name,
                                    status: item.progress_status,
                                    color: item.progress_status === WoProgressStatus.Pending ? '#c2c2c2' : ''
                                }); })) || [] }));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MessageStore.prototype.api = function () {
        return {
            getReactiveWoUnReadMessages: function () {
                return Q(http.post("/RSP/Message/GetReactiveWoUnReadMessages"));
            },
            getMessageDetail: function (id, isReactive) {
                return Q(http.post("/RSP/Message/" + id + "/GetMessageDetail", { isReactive: isReactive }, __assign({}, Api.withForm)));
            },
            markAsRead: function (id, isReactive) {
                return Q(http.post("/RSP/Message/" + id + "/MarkAsReads", { isReactive: isReactive }, __assign({}, Api.withForm)));
            },
            sendMessage: function (id, sendMessage) {
                return Q(http.post("/RSP/Message/wos/" + id + "/SendMessage", __assign({}, sendMessage), __assign({}, Api.withForm)));
            },
            replyMessage: function (id, replyMessage) {
                return Q(http.post("/RSP/Message/" + id + "/ReplyMessage", __assign({}, replyMessage), __assign({}, Api.withForm)));
            },
            getIsEnableCommunicationWithPM: function () {
                return Q(http.get("/RSP/Message/IsEnableCommunicationWithPMOnRSP"));
            },
            getWoStatusTimeLines: function (woId) {
                return Q(http.get("/RSP/ReactiveWo/GetWOStatusTimeLine?woId=" + woId));
            }
        };
    };
    __decorate([
        observable
    ], MessageStore.prototype, "unReadMessages", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "messagesDetail", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "woStatusData", void 0);
    __decorate([
        action
    ], MessageStore.prototype, "getReactiveWoUnReadMessages", null);
    __decorate([
        action
    ], MessageStore.prototype, "getMessageDetail", null);
    __decorate([
        action
    ], MessageStore.prototype, "markAsRead", null);
    __decorate([
        action
    ], MessageStore.prototype, "sendMessage", null);
    __decorate([
        action
    ], MessageStore.prototype, "replyMessage", null);
    __decorate([
        action
    ], MessageStore.prototype, "getIsEnableCommunicationWithPM", null);
    __decorate([
        action
    ], MessageStore.prototype, "clearUnReadMessages", null);
    __decorate([
        action
    ], MessageStore.prototype, "clearMessageDetail", null);
    __decorate([
        action
    ], MessageStore.prototype, "getWoStatusTimeLines", null);
    return MessageStore;
}());
export default MessageStore;
